/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevCodeIcon24Regular = forwardRef('DevCodeIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M15.418 3.216a.75.75 0 0 0-1.436-.432l-5.4 18a.75.75 0 0 0 1.436.431l5.4-18Z" }),
        React.createElement("path", { d: "M17.526 5.565a.75.75 0 0 1 1.061 0l4.631 4.632a2.55 2.55 0 0 1 0 3.606l-4.631 4.632a.75.75 0 1 1-1.06-1.061l4.63-4.631a1.05 1.05 0 0 0 0-1.485l-4.63-4.632a.75.75 0 0 1 0-1.06Z" }),
        React.createElement("path", { d: "M6.458 5.585a.75.75 0 0 1 0 1.06l-4.612 4.613a1.05 1.05 0 0 0 0 1.485l4.612 4.611a.75.75 0 0 1-1.061 1.061L.785 13.803a2.55 2.55 0 0 1 0-3.606l4.612-4.612a.75.75 0 0 1 1.06 0Z" })));
});
